import React, { useEffect, useState } from "react";
import RequestCard from "./RequestCard";
import axios from "axios";
import { Trans, withTranslation,useTranslation } from "react-i18next";

const RequestList = ({ user, handleAlert }) => {
  const [requests, setRequests] = useState([]);

  const deleteOldRequest=async()=>{
    const url = localStorage.getItem("api_url");
    await axios({
      method:"get",
      url:url+"delete_old_request/"+user.acceptance_code,
      config: { headers: { "Content-Type": "multipart/form-data" } },
    }).then((res)=>{
      const response = res.data;
      if(response.status==true){
        getRequests()
      }
    })
  }

  const getRequests = async () => {
    const url = localStorage.getItem("api_url");
    await axios({
      method: "post",
      url: url + "get_match_request/" + user.acceptance_code,
      config: { headers: { "Content-Type": "multipart/form-data" } },
    }).then((res) => {
      const response = res.data;
      if (response.status != "true") {
        handleAlert(true, "Failed request", response.message, null,false);
      } else {
        setRequests(response.data);
      }
    });
  };
  useEffect(() => {
    if(user){
      getRequests()
    }
  }, [user]);

  return (
    <div className="request-part">
      {requests && requests.length == 0 && (
        <div className="no-req-container">
          <i class="fa-solid fa-circle-xmark"></i>
          <p> <Trans i18nKey="No New Requests">No New Requests</Trans></p>
        </div>
      )}
      {requests &&
        requests.map((data, index) => (
          <RequestCard
            data={data}
            key={index}
            getData={getRequests}
            user={user}
            handleAlert={handleAlert}
          />
        ))}
    </div>
  );
};

export default RequestList;
